/**
 * @generated SignedSource<<3c268a786c9169f1d8d40d67fa7a7e3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UrlMappingMatchType = "EXACT" | "PREFIX" | "REGEX" | "HOST_PATH" | "TRANSFORM" | "%future added value";
export type UrlMappingListTab_Query$variables = {
  active?: boolean | null;
  count?: number | null;
  cursor?: string | null;
  matchType?: UrlMappingMatchType | null;
  searchTerm?: string | null;
  urlSearch?: string | null;
  id: string;
};
export type UrlMappingListTab_QueryVariables = UrlMappingListTab_Query$variables;
export type UrlMappingListTab_Query$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"UrlMappingListTab_user">;
  } | null;
};
export type UrlMappingListTab_QueryResponse = UrlMappingListTab_Query$data;
export type UrlMappingListTab_Query = {
  variables: UrlMappingListTab_QueryVariables;
  response: UrlMappingListTab_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "active"
},
v1 = {
  "defaultValue": 120,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "matchType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlSearch"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v8 = {
  "kind": "Variable",
  "name": "active",
  "variableName": "active"
},
v9 = {
  "kind": "Variable",
  "name": "matchType",
  "variableName": "matchType"
},
v10 = {
  "kind": "Variable",
  "name": "searchTerm",
  "variableName": "searchTerm"
},
v11 = {
  "kind": "Variable",
  "name": "urlSearch",
  "variableName": "urlSearch"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UrlMappingListTab_Query",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "UrlMappingListTab_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "UrlMappingListTab_Query",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v14/*: any*/),
                "concreteType": "UrlMappingConnection",
                "kind": "LinkedField",
                "name": "urlMappings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UrlMappingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UrlMapping",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "matchType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "priority",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sourceUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sourceHost",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sourcePath",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "regexPattern",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "destinationUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "conditions",
                            "storageKey": null
                          },
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v14/*: any*/),
                "filters": [
                  "searchTerm",
                  "urlSearch",
                  "active",
                  "matchType"
                ],
                "handle": "connection",
                "key": "UrlMappingListTab_urlMappings",
                "kind": "LinkedHandle",
                "name": "urlMappings"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UrlMappingCacheStatus",
                "kind": "LinkedField",
                "name": "urlMappingCache",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "present",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expiresAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "remainingSeconds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ttlSeconds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "962f3496892af0cbb761da1abf9390aa",
    "id": null,
    "metadata": {},
    "name": "UrlMappingListTab_Query",
    "operationKind": "query",
    "text": "query UrlMappingListTab_Query(\n  $active: Boolean\n  $count: Int = 120\n  $cursor: String\n  $matchType: UrlMappingMatchType\n  $searchTerm: String\n  $urlSearch: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...UrlMappingListTab_user_3z2muK\n    id\n  }\n}\n\nfragment UrlMappingCacheStatus_user on User {\n  urlMappingCache {\n    present\n    expiresAt\n    remainingSeconds\n    ttlSeconds\n  }\n}\n\nfragment UrlMappingListTab_user_3z2muK on User {\n  urlMappings(first: $count, after: $cursor, searchTerm: $searchTerm, urlSearch: $urlSearch, active: $active, matchType: $matchType) {\n    totalCount\n    edges {\n      node {\n        id\n        ...UrlMappingTableDataRow_urlMapping\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...UrlMappingCacheStatus_user\n  id\n}\n\nfragment UrlMappingTableDataRow_urlMapping on UrlMapping {\n  id\n  name\n  active\n  matchType\n  priority\n  sourceUrl\n  sourceHost\n  sourcePath\n  regexPattern\n  destinationUrl\n  conditions\n}\n"
  }
};
})();

(node as any).hash = "ef690aa341c6f9fed81b43115da74334";

export default node;
